import React from 'react';
import { MenuItem } from '@material-ui/core';
import { Order, getOrderLabel } from '../../../../Enums';
import StyledSelect from '../StyledSelect';
import InputTitle from '../InputTitle';

import './Step2-SortingRuleSection.scss';

/**
 * @typedef {{value: Order, label: string}} SelectOption
 * @type {SelectOption[]}
 */
const orderOptions = Object.values(Order).map((x) => ({
    value: x, label: getOrderLabel(x),
}));

/**
 * @param {{
 *  currentAwardingRule: ApiAdmin.IBodyAwardingRules,
 *  onChange: Function,
 *  isDisabled: boolean,
 *  fieldValidationErrors: {[Key: string] : boolean},
 * }} props
 */
function BySubmittedRequestDateTimeParameter(props) {
    const {
        currentAwardingRule,
        onChange = () => {},
        isDisabled,
        fieldValidationErrors,
    } = props;
   
    const selectedOrder = orderOptions.find((x) => x.value === currentAwardingRule.order);

    return (
        <div className="srs--dataviewCustomHyperfind-container">
            <div className="rse--selection-field-container srs-orderType-container">
                <InputTitle>Order type</InputTitle>
                <StyledSelect
                    labelId="select-sort-order-type-label"
                    id="select-sort-order-type-type"
                    disabled={isDisabled}
                    renderValue={(/** @type {string} */
                        _,
                    ) => selectedOrder?.label}
                    value={selectedOrder}
                    onChange={(/** @type {React.ChangeEvent<{ name?: string; value: string }>} */
                        event,
                    ) => onChange('order', event.target.value)}
                >
                    {orderOptions.map((x) => (
                        <MenuItem
                            value={x.value}
                            key={`SelectItem_${x.label}`}
                        >
                            {x.label}
                        </MenuItem>
                    ))}
                </StyledSelect>
                {
                    fieldValidationErrors.order ? <span style={{ color: 'red' }}>Please select a sorting order</span> : null
                }
            </div>
        </div>
    );
}

export default BySubmittedRequestDateTimeParameter;